import React from 'react';
import { bestSellers } from '../data/products';
export function BestSellers() {
  return <section id="best-sellers" aria-labelledby="best-sellers-heading" className="w-full bg-white pb-24 pt-4 md:pb-36 md:pt-6" data-id="element-15" data-mp="u9h5eciwuvut">
      <div className="mx-auto max-w-editorial px-6 md:px-12 lg:px-20" data-id="element-16" data-mp="18a1o78otsrob">
        <div className="flex flex-col items-center text-center" data-id="element-17" data-mp="14628gsbddww0">
          <h2 id="best-sellers-heading" className="font-serif text-[2rem] uppercase leading-tight tracking-[0.06em] text-maroon md:text-[2.6rem]" data-id="element-18" data-mp="1i6mtzw8o66t7">
            Best Sellers
          </h2>
        </div>

        <ul className="mx-auto mt-12 grid max-w-4xl grid-cols-1 gap-x-12 gap-y-14 sm:grid-cols-2 md:mt-16" data-id="element-19" data-mp="1rveh9r2sc2xs">
          {bestSellers.map(product => <li key={product.id} className="group flex h-full flex-col text-center" data-id="element-20" data-mp="20xe10r56pl4f">
              <div className="overflow-hidden bg-ivory" data-id="element-21" data-mp="20v1kmif2rith">
                <img src={product.image} alt={product.name} className="aspect-square w-full object-cover transition-transform duration-300 ease-luxe group-hover:scale-[1.03]" data-id="element-22" data-mp="1vzm8pw0mnwzp" />
              </div>
              <h3 className="mt-6 font-serif text-[18px] font-light text-maroon" data-id="element-23" data-mp="3lz72z6c0se9i">
                {product.name}
              </h3>
              <p className="mt-2 font-sans text-[12px] font-light uppercase tracking-[0.14em] text-maroon-mute" data-id="element-24" data-mp="3qys3hl6u8uoc">
                {product.detail}
              </p>
              <p className="mt-3 font-serif text-xl text-maroon" data-id="element-25" data-mp="3t17desn81tp">{product.price}</p>
              <button type="button" className="mt-6 w-full whitespace-nowrap bg-gold px-6 py-3.5 font-display text-[11px] font-light uppercase tracking-[0.3em] text-white transition-colors duration-150 ease-luxe hover:bg-gold-deep focus-visible:bg-gold-deep focus-visible:outline-none" data-id="element-26" data-mp="8k11kcado5si">
                Add to bag
              </button>
            </li>)}
        </ul>
      </div>
    </section>;
}